<button
  type="button"
  class="line-style-trigger"
  [class.compact]="compact"
  [class.is-open]="isOpen"
  [disabled]="disabled"
  [matMenuTriggerFor]="menu"
  [matTooltip]="tooltip"
  [matTooltipDisabled]="!tooltip"
  (menuOpened)="isOpen = true"
  (menuClosed)="isOpen = false"
  (click)="$event.stopPropagation()"
>
  <ng-container
    *ngTemplateOutlet="
      preview;
      context: { $implicit: selected, width: previewWidth }
    "
  ></ng-container>
  @if (!compact) {
  <firebird-web-icon
    class="line-style-arrow"
    name="arrow-down-black"
    width="12px"
    height="10px"
  ></firebird-web-icon>
  }
</button>

<mat-menu #menu="matMenu" class="line-style-select-menu">
  @for (option of options; track option.value) {
  <button
    mat-menu-item
    type="button"
    class="line-style-option"
    [class.is-selected]="option.value === value"
    (click)="select(option)"
  >
    <ng-container
      *ngTemplateOutlet="
        preview;
        context: { $implicit: option, width: menuPreviewWidth }
      "
    ></ng-container>
    @if (option.label && hasPreview(option)) {
    <span class="line-style-option-label">{{ option.label }}</span>
    }
  </button>
  }
</mat-menu>

<ng-template #preview let-option let-width="width">
  @if (hasPreview(option)) {
  <svg
    class="line-style-preview"
    [attr.width]="width"
    [attr.height]="previewHeight"
    [attr.viewBox]="'0 0 ' + width + ' ' + previewHeight"
  >
    @if (option.svgDasharray) {
    <line
      x1="0"
      [attr.y1]="previewHeight / 2"
      [attr.x2]="width"
      [attr.y2]="previewHeight / 2"
      stroke="currentColor"
      [attr.stroke-width]="strokeWidth(option)"
      [attr.stroke-dasharray]="dasharray(option)"
    />
    } @if (option.marker) {
    <path fill="currentColor" [attr.d]="markerPath(option, width)" />
    }
  </svg>
  } @else {
  <span class="line-style-text">{{ option?.label }}</span>
  }
</ng-template>
